import apiClient from './index';

const vadainFabricsBasePath = `vadain-fabrics/`

export default {
  async getVadainFabrics(queryParams) {
    return await apiClient.get(vadainFabricsBasePath, {'params': queryParams})
  },

  async getVadainFabricDetails({fabricUuid}) {
    return await apiClient.get(`${vadainFabricsBasePath}${fabricUuid}/`)
  }
}
